import React, { useEffect, useState } from 'react';
import { Box, Typography, debounce } from '@mui/material';
import { SmartFilter } from '../../components/common/SmartFilter';
import { SellOldACList } from '../../components/ui/list/SellOldACLIst';
import { SellOldACHeader } from '../../utils/constants';
import { GetEnquiry } from '../../services/sellOldAC';
import Pagination from '../../components/atoms/Pagination';
import AddSellOldACRequest from './AddSellOldACRequest';
import { usePaginationParams } from '../../hooks/usePaginationParams';
import { useScrollRestoration } from '../../hooks/useScrollRestoration';

const SellOldAC: React.FC = () => {
  const { page, rowsPerPage, setPage, setRowsPerPage } = usePaginationParams();
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const scrollRef = useScrollRestoration<HTMLDivElement>(!isLoading);
  const [oldACList, setOldACList] = useState([]);
  const [totalPage, setTotalPage] = useState();
  const [addOpen, setAddOpen] = useState(false);

  useEffect(() => {
    fetchOldAC(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);

  const fetchOldAC = async (
    page: number,
    limit: number,
    searchQuery?: string,
  ) => {
    try {
      setIsLoading(true);
      const response = await GetEnquiry({
        page,
        limit,
        searchQuery,
      });

      setOldACList(response.data);
      setTotalPage(response.pagination.totalCount);
    } catch (error) {
      console.error('Failed to fetch bookings:', error);
    } finally {
      setIsLoading(false);
    }
  };
  console.log('oldACList', totalPage);

  const refreshList = () => {
    fetchOldAC(page, rowsPerPage, searchQuery);
  };

  const handleSearchRefresh = debounce((search: string) => {
    setSearchQuery(search);
    setPage(1);
  }, 500);


  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage + 1); // API expects 1-based page index
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      <SmartFilter
        title="Sell Old AC"
        createFilter={['SEARCH', 'ADD']}
        filterdrawerSize="sm"
        filterHeader={'Filter Requests'}
        addbuttontitle="Add Request"
        onSearch={handleSearchRefresh}
        onSaved={refreshList}
        onNavigate={() => setAddOpen(true)}
      />

      <AddSellOldACRequest
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onSaved={refreshList}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          p: 1,
        }}
      >
        <Box
          ref={scrollRef}
          sx={{
            height: '100%',
            maxHeight: '100%',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
          }}
        >
          {oldACList.length <= 0 && !isLoading ? (
            <Typography textAlign={'center'} marginTop={'20%'}>
              No Requests Found
            </Typography>
          ) : (
            <SellOldACList
              headerCells={SellOldACHeader}
              technicians={oldACList}
              isLoading={isLoading}
              onUpdate={refreshList}
            />
          )}
        </Box>
        <Box display={'block'} bottom={0} right={0}>
          <Pagination
            count={totalPage || 0}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SellOldAC;

